// Placeholder for when modal and snackbar messages need to be removed
export const removeOverlaidMessages = () => undefined;
